import { Point } from "../models/Point";
import { a } from "../shared/globalState/a";
import { determineSideOfOffsetRoute, findIntersection, findPairs } from "../shared/common";
import { updateAndDrawShapes } from "../shared/render/shapes";
import { Vector } from "../models/Vector";

import { copyRoute } from "./joinObserver";

import { ObjectTypes } from "../shared/enums";
import { Line } from "../models/shapes/Line";
import { Shape } from "../shared/types";
import { checkSameType, getFirstType } from "../shared/utils/shapeFilters";

/**
 * COMMENT: вот эта функция работает неплохо, по использованию на данный момент - вплоне надёжно
 */
function makeOffset(arrayOfLines: Line[], mouse: Point, width: number) {

    var result = determineSideOfOffsetRoute(arrayOfLines, mouse);

    let offsetLines: Line[] = [];

    // позиции новых линий

    arrayOfLines.forEach(s => {
        
        let offsetLine = s.getClone();
        let vec = new Vector(s.start, s.end);
        let offsetX = vec.nx * width / 2;
        let offsetY = vec.ny * width / 2;
        if (result > 0) {
            offsetLine.start = new Point(s.start.x - offsetX, s.start.y - offsetY);
            offsetLine.end = new Point(s.end.x - offsetX, s.end.y - offsetY);
        }
        else {
            offsetLine.start = new Point(s.start.x + offsetX, s.start.y + offsetY);
            offsetLine.end = new Point(s.end.x + offsetX, s.end.y + offsetY);
        }
        offsetLines.push(offsetLine);

    });

    // соединение новых линий
    let routeSegments = copyRoute(offsetLines);
    let joins = routeSegments.map(s => [s.startJ, s.endJ]).flat();
    
    // функция findPairs здесь не нужна, так как возвращает просто повтор одного и того же объекта
    let pairs = findPairs(joins.map(j=>j.id));

    let pairJoins: any[] = [];
    
    pairs.forEach(pair => {
        let i1 = joins.findIndex((v, i) => v.id === pair[0]);
        let i2 = joins.findIndex((v, i) => v.id === pair[1] && i !== i1);
        pairJoins.push([joins[i1], joins[i2]]);
    });

    let pairSeg: any[] = [];
    

    (pairJoins as any[]).forEach(pair => {
        if (pair[0].id && pair[1].id) {
            let seg1 = routeSegments.find(s => s.id === pair[0].ownerId);
            let seg2 = routeSegments.find(s => s.id === pair[1].ownerId);
            if (seg1 && seg2) {
                pairSeg.push([seg1, seg2]);
            }
        }
    });

    

    (pairSeg as any[]).forEach(pair => {
        let seg1 = pair[0];
        let seg2 = pair[1];
        let intersection = findIntersection(seg1, seg2);

        if (intersection) {
            // здесь нужно узнать, какими концами соединяются линии
            
            
            if (seg1.startJ.id === seg2.startJ.id && seg1.startJ.id && seg2.startJ.id) {
                
                seg1.start = intersection;
                seg2.start = intersection;
            }
            else if (seg1.endJ.id === seg2.endJ.id && seg1.endJ.id && seg2.endJ.id) {
                
                seg1.end = intersection;
                seg2.end = intersection;
            }
            else if (seg1.startJ.id === seg2.endJ.id && seg1.startJ.id && seg2.endJ.id) {
                
                seg1.start = intersection;
                seg2.end = intersection;
            }
            else if (seg1.endJ.id === seg2.startJ.id && seg1.endJ.id && seg2.startJ.id) {
                
                seg1.end = intersection;
                seg2.start = intersection;
            }
        }
    })

    routeSegments.forEach(s => s.isSelected = true);
    

    (a.shapes as any[]).push(...routeSegments);

    updateAndDrawShapes();

}

// Helper functions moved to shared/utils/shapeFilters.ts

function makeOffsetGuide(shapes: Shape[], mouse: Point, width: number) {
    
    // проверить, все ли объекты одного типа
    if (!checkSameType(shapes)) {
        console.error('>> Фигуры должны быть одного типа');
        return; // выход из функции, если объекты не одного типа
    }

    switch (getFirstType(shapes)) {
        case ObjectTypes.circle:
            return;
        case ObjectTypes.rectangle:

            if (shapes.length > 1) {
                return;
            }
            
            shapes = (shapes[0] as any).getGuides();
            
        default:
            break;
    }

    var result = determineSideOfOffsetRoute(shapes, mouse);

    let offsetLines: any[] = [];

    // позиции новых линий

    shapes.forEach(s => {
        
        let offsetLine = (s as any).getCloneGuide();
        let vec = new Vector((s as any).start, (s as any).end);
        let offsetX = vec.nx * width / 2;
        let offsetY = vec.ny * width / 2;
        if (result > 0) {
            offsetLine.start = new Point((s as any).start.x - offsetX, (s as any).start.y - offsetY);
            offsetLine.end = new Point((s as any).end.x - offsetX, (s as any).end.y - offsetY);
        }
        else {
            offsetLine.start = new Point((s as any).start.x + offsetX, (s as any).start.y + offsetY);
            offsetLine.end = new Point((s as any).end.x + offsetX, (s as any).end.y + offsetY);
        }
        offsetLines.push(offsetLine);

    });

    // соединение новых линий
    let routeSegments = copyRoute(offsetLines);
    let joins = routeSegments.map(s => [s.startJ, s.endJ]).flat();
    
    // функция findPairs здесь не нужна, так как возвращает просто повтор одного и того же объекта
    let pairs = findPairs(joins.map(j=>j.id));

    let pairJoins: any[] = [];
    
    pairs.forEach(pair => {
        let i1 = joins.findIndex((v, i) => v.id === pair[0]);
        let i2 = joins.findIndex((v, i) => v.id === pair[1] && i !== i1);
        pairJoins.push([joins[i1], joins[i2]]);
    });

    let pairSeg: any[] = [];
    

    (pairJoins as any[]).forEach(pair => {
        if (pair[0].id && pair[1].id) {
            let seg1 = routeSegments.find(s => s.id === pair[0].ownerId);
            let seg2 = routeSegments.find(s => s.id === pair[1].ownerId);
            if (seg1 && seg2) {
                pairSeg.push([seg1, seg2]);
            }
        }
    });

    

    (pairSeg as any[]).forEach(pair => {
        let seg1 = pair[0];
        let seg2 = pair[1];
        let intersection = findIntersection(seg1, seg2);

        if (intersection) {
            // здесь нужно узнать, какими концами соединяются линии
            
            
            if (seg1.startJ.id === seg2.startJ.id && seg1.startJ.id && seg2.startJ.id) {
                
                seg1.start = intersection;
                seg2.start = intersection;
            }
            else if (seg1.endJ.id === seg2.endJ.id && seg1.endJ.id && seg2.endJ.id) {
                
                seg1.end = intersection;
                seg2.end = intersection;
            }
            else if (seg1.startJ.id === seg2.endJ.id && seg1.startJ.id && seg2.endJ.id) {
                
                seg1.start = intersection;
                seg2.end = intersection;
            }
            else if (seg1.endJ.id === seg2.startJ.id && seg1.endJ.id && seg2.startJ.id) {
                
                seg1.end = intersection;
                seg2.start = intersection;
            }
        }
    });

    (a.shapes as any[]).push(...routeSegments);

    updateAndDrawShapes();



}




export { makeOffset, makeOffsetGuide, checkSameType };